<template>
    <div class="scholar safe-distance-top">
        <div class="scholar_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <h3 class="my">学者认证</h3>
        </div>
        <div class="scholar_bottom">
            <van-cell-group class="cell_group_box">
                <van-cell class="upload_box" :required="true" title="头像" center>
                    <template>
                        <van-image
                            class="upload_img"
                            round
                            width="35px"
                            height="35px"
                            :src="
                                subInfo.userInfo.headPhoto
                                    ? $global.imgUrl + subInfo.userInfo.headPhoto
                                    : require('@/assets/img/mobile-img/upload-default.png')
                            "
                            @click="preview(subInfo.userInfo.headPhoto)"
                        />
                        <van-uploader
                            :max-size="1 * 1024 * 1024"
                            :before-read="beforeRead"
                            :after-read="clzpAfterRead"
                            @oversize="onOversize"
                        >
                            <van-icon class="upload_icon" name="arrow" />
                        </van-uploader>
                    </template>
                </van-cell>
                <van-cell
                    :required="true"
                    title="姓名"
                    :value="scholarName"
                    is-link
                    to="fullname"
                />
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell center :required="true" title="职称">
                    <van-button
                        size="small"
                        style="border: none; color: #4a79f1; font-size: 14px"
                        @click="toAdd('TitleList', '/Atitle')"
                    >
                        添加
                    </van-button>
                </van-cell>
                <van-cell
                    :title="'职称' + Number(index + 1)"
                    is-link
                    v-for="(item, index) in TitleList"
                    :key="index"
                    :to="{
                        path: 'Adeletetitle',
                        query: { item: JSON.stringify(item), indexs: index },
                    }"
                >
                    <span>
                        <span>{{ item.levelOneName }}</span>
                        <span v-if="item.levelTwo">-{{ item.levelTwo }}</span>
                    </span>
                </van-cell>
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell :required="true" title="学科领域">
                    <van-button
                        size="small"
                        style="border: none; color: #4a79f1; font-size: 14px"
                        @click="toAdd('subjectsList', '/Aarea')"
                    >
                        添加
                    </van-button>
                </van-cell>
                <van-cell
                    :title="'学科领域' + Number(index + 1)"
                    value="物理学"
                    is-link
                    :to="{
                        path: 'Adeletearea',
                        query: { item: JSON.stringify(item), indexs: index },
                    }"
                    v-for="(item, index) in subjectsList"
                    :key="index"
                >
                    <span>
                        <span>{{ item.levelOneName }}</span
                        >-<span>{{ item.levelTwoName }}</span>
                    </span>
                </van-cell>
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell
                    class="omit"
                    title="研究方向"
                    :value="researchDirection"
                    is-link
                    to="Astudy"
                    :required="true"
                />
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell title="任职机构" :required="true">
                    <van-button
                        size="small"
                        style="border: none; color: #4a79f1; font-size: 14px"
                        @click="
                            toAdd('scholarPresentUnitsList', '/Adeletebe', {
                                sessionName: 'subInfo',
                                key: 'scholarPresentUnits',
                            })
                        "
                        >添加</van-button
                    >
                </van-cell>
                <van-cell
                    v-for="(item, index) in scholarPresentUnitsList"
                    :key="index"
                    :title="'任职机构' + Number(index + 1)"
                    :value="item.unitName"
                    is-link
                    :to="{
                        path: 'Adeletebe',
                        query: {
                            item: JSON.stringify(item),
                            index,
                            key: 'scholarPresentUnits',
                            sessionName: 'subInfo',
                        },
                    }"
                />
            </van-cell-group>
        </div>
        <div class="exit">
            <van-button class="bot" @click="tijiao">提交</van-button>
        </div>
    </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
export default {
    name: "scholar",
    data() {
        return {
            // 储存的数据
            subInfo: {
                userInfo: {
                    headPhoto: "",
                    realname: "",
                    researchDirection: "",
                },
                titles: [],
                subjects: [],
                scholarPresentUnits: [],
            },
            // 职称
            TitleList: [],
            // 学科领域
            subjectsList: [],
            // 研究方向
            researchDirection: "",
            // 任职机构
            scholarPresentUnitsList: [],
            // 姓名
            scholarName: "",
        };
    },
    created() {
        if (sessionStorage.getItem("subInfo")) {
            this.subInfo = JSON.parse(sessionStorage.getItem("subInfo"));
            this.formateInfo();
        } else {
            this.getUserDetails();
        }
    },
    methods: {
        toAdd(key, path, query) {
            if (this[key].length < 10) {
                this.$router.push({ path, query });
            } else {
                Toast("最多能添加10条");
            }
        },
        formateInfo() {
            // 姓名
            this.scholarName = this.subInfo.userInfo.realname;
            // 研究方向
            this.researchDirection = this.subInfo.userInfo.researchDirection;
            // 遍历职称
            if (this.subInfo.titles && this.subInfo.titles.length !== 0) {
                for (let i = 0; i < this.subInfo.titles.length; i++) {
                    this.TitleList.push(this.subInfo.titles[i]);
                }
            }
            // 遍历学科领域
            if (this.subInfo.subjects && this.subInfo.subjects.length !== 0) {
                for (let i = 0; i < this.subInfo.subjects.length; i++) {
                    this.subjectsList.push(this.subInfo.subjects[i]);
                }
            }
            // 遍历任职机构
            if (this.subInfo.scholarPresentUnits && this.subInfo.scholarPresentUnits.length !== 0) {
                for (let i = 0; i < this.subInfo.scholarPresentUnits.length; i++) {
                    this.scholarPresentUnitsList.push(this.subInfo.scholarPresentUnits[i]);
                }
            }
        },
        // 学者基本信息
        async getUserDetails() {
            let {
                content: { detail },
            } = await this.$apis.userServe.userDetails();
            this.subInfo.userInfo.headPhoto =
                detail.userInfo && detail.userInfo.headPhoto ? detail.userInfo.headPhoto : "";
            this.subInfo.userInfo.realname =
                detail.userInfo && detail.userInfo.realname ? detail.userInfo.realname : "";
            this.subInfo.userInfo.researchDirection =
                detail.userInfo && detail.userInfo.researchDirection
                    ? detail.userInfo.researchDirection
                    : "";
            this.subInfo.titles = detail.sysUserTitle ? detail.sysUserTitle : [];
            this.subInfo.subjects = detail.sysUserSubject ? detail.sysUserSubject : [];
            this.subInfo.scholarPresentUnits = detail.scholarPresentUnit
                ? detail.scholarPresentUnit
                : [];
            sessionStorage.setItem("subInfo", JSON.stringify(this.subInfo));
            this.formateInfo();
        },
        to() {
            if (this.$route.query.out) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            // this.$router.push("My");
            window.history.go(-1);
            sessionStorage.removeItem("subInfo");
        },
        // 预览上传的图片
        preview(url) {
            if (url) {
                ImagePreview({
                    images: [this.$global.imgUrl + url],
                    closeable: true,
                });
            }
        },
        //校验上传图片大小
        onOversize(file) {
            Toast("文件大小不能超过1MB");
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        //照片上传事件方法
        async clzpAfterRead(file) {
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await this.$apis.myServe.uploadFileMannual(formData);
            this.$set(this.subInfo.userInfo, "headPhoto", res.data);
            sessionStorage.setItem("subInfo", JSON.stringify(this.subInfo));
        },
        // 提交
        async tijiao() {
            if (
                this.subInfo.userInfo.headPhoto !== "" &&
                this.subInfo.userInfo.realname !== "" &&
                this.subInfo.userInfo.researchDirection !== "" &&
                this.subInfo.scholarPresentUnits !== undefined &&
                this.subInfo.subjects !== undefined &&
                this.subInfo.titles !== undefined &&
                this.subInfo.scholarPresentUnits.length !== 0 &&
                this.subInfo.subjects.length !== 0 &&
                this.subInfo.titles.length !== 0
            ) {
                let res = await this.$apis.userServe.subscholar(this.subInfo);
                if (res.data.resultCode === "200") {
                    Toast("提交成功");
                    this.$router.push({
                        path: "scholarStatus",
                        query: { title: "学者认证" },
                    });
                } else {
                    Toast(res.data.resultDesc);
                }
            } else {
                Toast("请填写必填项");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.scholar {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .scholar_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;

        .my {
            font-size: 18px;
            color: #333333;
        }
    }

    .scholar_bottom {
        width: 94%;
        height: 100%;
        margin: 0 auto;
        padding-bottom: 20px;

        .scholar_text {
            width: 94%;
            height: 48px;
            background: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 12px auto;
            line-height: 48px;
        }

        .cell_group_box {
            margin-top: 13px;
            border-radius: 8px;
            overflow: hidden;
            .van-cell__value {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .upload_box {
            .upload_img {
                margin-right: 10px;
                vertical-align: middle;
            }

            .upload_img_card {
                border-radius: 5px;
                overflow: hidden;
            }

            .upload_icon {
                height: 24px;
                font-size: 16px;
                line-height: 24px;
                color: #969799;
                vertical-align: middle;
            }
        }

        .van-cell-group--inset {
            margin: 0px 11px;
        }
    }

    .exit {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 22px;

        .bot {
            width: 94%;
            height: 44px;
            border-radius: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
            background: #4a79f1;
        }
    }
}
</style>
